/** @format */

import React, { FC, memo, useState } from "react";
import styled, { css } from "styled-components";
import { v4 as uuidv4 } from "uuid";
import Box from "../box/Box";
import { ButtonProps } from "./Button.types";
import { StyledButton } from "./Button.styled";
import Icon from "../../core/icon/Icon";

const Button: FC<ButtonProps> = ({
  trackId,
  text,
  children,
  leadingIcon,
  trailingIcon,
  transform,
  size,
  width,
  loading,
  onClick,
  disabled,
  type = "button",
  throttle = 200,
  disabledNotice,
  ...props
}) => {
  const [triggerTooltipShake, setTriggerTooltipShake] = useState(false);
  const buttonId = React.useRef(trackId || `tooltip-${uuidv4()}`);
  const reference = React.useRef<HTMLButtonElement>(null);
  const pause = React.useRef(false);
  const throttleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (!pause.current) {
      onClick?.(event);
      pause.current = true;
    }
    setTimeout(() => {
      pause.current = false;
    }, throttle);
  };
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (disabled) {
      setTriggerTooltipShake(!triggerTooltipShake);
      // we do this so that when clicking on an disabled button within a clickable area it opens the tooltip and not the clickable area
      // might need to make this more dynamic in the future
      event.stopPropagation();
      return;
    }
    if (typeof onClick === "function") throttleClick(event);
  };
  const iconSize = size === "small" || size === "sm" ? 14 : 16;
  const iconDimensions = { width: iconSize, height: iconSize };
  return (
    <>
      {/* {disabled && (
        <Tooltip
          anchorSelect={`#${buttonId.current}`}
          place="top"
          openOnClick
          shake={triggerTooltipShake}
          label={disabledNotice}
          leadingIcon="Alert"
          color="alert"
          target={reference}
        />
      )} */}
      <StyledButton
        id={buttonId.current}
        className={trackId && `button umami--click--${trackId}`}
        type={type}
        text={text}
        width={width}
        isLoading={loading}
        // disabled={loading}
        isDisabled={disabled}
        onClick={handleClick}
        size={size}
        ref={reference}
        {...props}
      >
        {(leadingIcon || loading) && (
          <Box position={(!leadingIcon && text && "absolute") || undefined}>
            <Icon
              name={loading ? "loading" : leadingIcon}
              transform={transform}
              {...iconDimensions}
              {...props.leadingIconProps}
            />
          </Box>
        )}
        {children && children}
        {text && (
          <span style={{ opacity: loading && !leadingIcon ? 0 : 1 }}>
            {text}
          </span>
        )}
        {trailingIcon && (
          <Box marginLeft="auto">
            <Icon name="gis/car" />
            <Icon
              name={trailingIcon}
              {...iconDimensions}
            />
          </Box>
        )}
      </StyledButton>
    </>
  );
};

export default memo(Button);
